import { render, staticRenderFns } from "./AccountGatewayAsset.vue?vue&type=template&id=06696078&scoped=true"
import script from "./AccountGatewayAsset.vue?vue&type=script&lang=js"
export * from "./AccountGatewayAsset.vue?vue&type=script&lang=js"
import style0 from "./AccountGatewayAsset.vue?vue&type=style&index=0&id=06696078&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../groovemail-ui/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06696078",
  null
  
)

export default component.exports